import type { GTabsItem } from '~/presentation/common';
import type { IconProps } from '@shopify/polaris';

import { ThemeTemplateIcon, ProductCostIcon, LinkIcon } from '@shopify/polaris-icons';
import { CampaignListingTabItem } from './CampaignListingTabItem';
import { GTabs, useWindowSize } from '~/presentation/common';
import { useCampaignFilterContext } from '../../contexts';
import { PagePackageIcon } from '~/presentation/icons';
import { InlineStack } from '@shopify/polaris';
import { ICampaignType } from '../../types';
import { useMemo } from 'react';

export interface TabCampaignListing {
  name: string;
  key: ICampaignType;
  icon: IconProps['source'];
}

const TAB_CAMPAIGN_LISTING: TabCampaignListing[] = [
  { name: 'Template', key: ICampaignType.TEMPLATE, icon: ThemeTemplateIcon },
  { name: 'Multipage', key: ICampaignType.TEMPLATE_BUNDLE, icon: PagePackageIcon },
  { name: 'Product price', key: ICampaignType.PRICE, icon: ProductCostIcon },
  { name: 'URL', key: ICampaignType.URL, icon: LinkIcon },
];
export const CampaignListingTab = () => {
  const { campaignType, handleCampaignTypeChange } = useCampaignFilterContext();
  const { isMobileTabletView } = useWindowSize();

  const tabSwitchItems: GTabsItem<ICampaignType>[] = useMemo(() => {
    return TAB_CAMPAIGN_LISTING.map((item) => ({
      label: item.name,
      value: item.key,
      icon: item.icon,
    }));
  }, []);

  return (
    <div className="z-10">
      {isMobileTabletView ? (
        <GTabs
          tabs={tabSwitchItems}
          selected={campaignType ?? ICampaignType.TEMPLATE}
          onChange={handleCampaignTypeChange}
        />
      ) : (
        <InlineStack gap="100" wrap={false}>
          {TAB_CAMPAIGN_LISTING.map((item) => {
            return <CampaignListingTabItem key={item.key} item={item} />;
          })}
        </InlineStack>
      )}
    </div>
  );
};
